var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoInfinity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 7,
    viewBox: "0 0 16 7",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "infinity_1_",
    "data-name": "infinity (1)",
    transform: "translate(-.001 -136.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48454",
    "data-name": "Path 48454",
    d: "M12.572,136.533c-1.786,0-3.714,1.766-4.571,2.65-.857-.884-2.786-2.65-4.571-2.65a3.5,3.5,0,0,0,0,7c1.786,0,3.714-1.766,4.571-2.65.857.884,2.786,2.65,4.571,2.65a3.5,3.5,0,0,0,0-7ZM3.43,142.366a2.334,2.334,0,0,1,0-4.667c1.257,0,2.926,1.446,3.787,2.333C6.357,140.921,4.692,142.366,3.43,142.366Zm9.143,0c-1.257,0-2.926-1.446-3.787-2.333.857-.888,2.525-2.333,3.787-2.333a2.334,2.334,0,0,1,0,4.667Z",
    fill: "#4d4d4d"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoInfinity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_infinity.d30cfa23a15a2c552888fb126606c972.svg";